module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Bezier-curve-1e4226d50ea302eca9451f07fc21d7f7.svg";